<template>
  <div class="text-xs-center">
    <v-dialog v-model="open" scrollable width="1000">
      <v-card>
        <v-card-title class="headline" primary-title>
          <v-icon class="pl-3 pr-3">info</v-icon>Metadata:
          {{ layer.title ? layer.title : "Metadata ikke tilgjengelig" }}
        </v-card-title>

        <v-card-text>
          <v-layout row align-center justify-center v-if="loading">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-layout>
          <div v-else>
            <div v-if="metadata">
              <v-subheader>Symbolisering</v-subheader>
              <v-layout class="pb-4" justify-start row>
                <img
                  v-if="
                    metadata.thumbnailUrl !==
                      appPublicUrl + '/link/thumbnails/null'
                  "
                  class="pl-3 pt-3"
                  :src="metadata.thumbnailUrl"
                  height="200"
                  width="200"
                />
                <div class="pa-3" v-else>Bilde ikke tilgjengelig</div>
              </v-layout>
              <v-subheader>Beskrivelse</v-subheader>
              <v-layout class="pb-4" justify-start row>
                <div
                  v-if="metadata.beskrivelse !== null"
                  v-html="metadata.beskrivelse"
                  class="pa-3"
                ></div>
                <div class="pa-3" v-else>Ingen beskrivelse</div>
              </v-layout>
              <v-subheader>Egenskaper</v-subheader>
              <v-data-table
                hide-actions
                :headers="headers"
                :items="metadata.felter"
              >
                <template v-slot:items="props">
                  <td>{{ props.item.atlasAlias }}</td>
                  <td>{{ props.item.fieldName }}</td>
                  <td>
                    {{ props.item.atlasSuffix ? props.item.atlasSuffix : "-" }}
                  </td>
                  <td>{{ props.item.fieldDescription }}</td>
                </template>
              </v-data-table>
              <v-subheader>Lenker</v-subheader>
              <v-layout align-start justify-start column>
                <v-btn
                  class="ml-0"
                  v-for="url in metadata.urls"
                  :key="url.url"
                  :href="url.url"
                  v-show="url.url !== null"
                  color="blue"
                  flat
                >
                  <v-icon class="pa-2" style="font-size: 14px;"
                    >mdi-open-in-new</v-icon
                  >Les mer om {{ url.text }}
                </v-btn>
                <v-btn
                  v-if="wmsUrl !== null"
                  class="ml-0"
                  :href="wmsUrl"
                  color="blue"
                  flat
                >
                  <v-icon class="pa-2" style="font-size: 14px;"
                    >mdi-open-in-new</v-icon
                  >Åpne WMS tjeneste (GetCapabilities) for dette kartlaget
                </v-btn>
              </v-layout>
            </div>
            <div v-else class="pa-3">
              Metadata er ikke tilgjengelig for dette kartlaget.
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="$emit('close')">
            Lukk
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MappingMixin from "@/mixins/mappingMixin";
export default {
  name: "LayerMetadata",
  data: function() {
    return {
      beskrivelse: "",
      loading: true,
      thumbnailUrl: "",
      restAdress: "",
      restIndex: "",
      urls: [],
      felter: [],
      headers: [
        {
          text: "Feltnavn",
          align: "left",
          value: "atlasAlias"
        },
        { text: "Database feltnavn", align: "left", value: "fieldName" },
        { text: "Benevning", align: "left", value: "atlasSuffix" },
        { text: "Feltbeskrivelse", align: "left", value: "fieldDescription" }
      ]
    };
  },
  mixins: [MappingMixin],
  props: {
    layer: Object,
    open: Boolean
  },
  computed: {
    ...mapState(["layerMetadata", "appPublicUrl"]),
    metadata() {
      return this.$store.getters["getLayerMetadataByAddressAndIndex"](
        this.layer.layer.url.replace(/(^\w+:|^)\/\//, ""),
        this.layer.id
      );
    },
    wmsUrl() {
      if (
        this.layer.parent.sourceJSON &&
        this.layer.parent.sourceJSON.supportedExtensions
          .toLowerCase()
          .includes("wms")
      ) {
        let parentLayerUrl = this.layer.parent.url;
        let wmsUrl =
          parentLayerUrl.replace("/rest/", "/") +
          "/WMSServer?request=GetCapabilities&service=WMS";
        return wmsUrl;
      } else {
        return null;
      }
    }
  },
  mounted() {
    this.restAdress = this.layer.layer.url.replace(/(^\w+:|^)\/\//, "");
    this.restIndex = this.layer.id;

    if (!this.metadata) {
      this.loadMetadata({
        restAdress: this.restAdress,
        restIndex: this.restIndex
      })
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error(error);
        });
    } else {
      this.loading = false;
    }
  }
};
</script>

<style></style>
